// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__itcmC","secondaryContainer":"styles_secondaryContainer__IwlfF","gradientText":"styles_gradientText__F1K8Y"};